<template>
  <div class="searchBox search-box">
    <div class="searchForm">
      <div class="item searchItem">
        <span>姓名：</span>
        <el-input v-model="staffName" size="medium"></el-input>
      </div>
      <div class="item searchItem">
        <span style="margin-left: 16px">手机号：</span>
        <el-input v-model="mobile" size="medium"></el-input>
      </div>
      <div class="item searchItem">
        <span>入职时间：</span>
        <date v-model="date" type="daterange"></date>
      </div>
      <div class="item searchItem">
        <el-button
          @click="search"
          type="primary"
          style="margin-left: 16px"
          size="medium"
          >查询
        </el-button>
        <el-button @click="reset()" style="margin-left: 16px" size="medium"
          >重置
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Date from "@/components/date.vue";
export default {
  name: "searchBox",
  components: {
    Date,
  },
  data() {
    return {
      staffName: "",
      mobile: "",
      date: [],
    };
  },
  methods: {
    search() {
      this.$emit("change", this.data);
    },
    reset() {
      this.staffName = "";
      this.mobile = "";
      this.date = [];
      this.$emit("change", this.data,'reset');
    },
  },
  computed: {
    data() {
      return {
        staffName: this.staffName,
        mobile: this.mobile,
        date: this.date ? this.date : [],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  .item {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    span {
      white-space: nowrap;
    }
  }
}
</style>
